import React from 'react';
import '../../../styles/dashboard/Announcements.css';
import tableData from './fakeData';
import * as Svg from '../../common/icons';

const LatestAnnouncements = ({
  setReadDetails,
  setDetailsID,
  setFormOpen,
  setSignClose,
  setAddNewForm
}) => {
  const handleRead = (id) => {
    setFormOpen(true);
    setReadDetails(true);
    setDetailsID(id);
    setSignClose(false);
    setAddNewForm(false);
  };

  return (
    <table className='table-announcement'>
      <thead className='thead'>
        <tr>
          <th scope='col'></th>
          <th scope='col'>Department</th>
          <th scope='col'>Created By</th>
          <th scope='col'>Due Date</th>
          <th scope='col'></th>
          <th scope='col'></th>
          <th scope='col'></th>
          <th scope='col'></th>
        </tr>
      </thead>
      {tableData.length > 0 ? (
        <tbody>
          {tableData.map((data, id) => {
            return (
              <tr key={id} onClick={() => handleRead(data.id)}>
                <td>{data.title}</td>
                <td>{data.dept}</td>
                <td>{data.createdBY}</td>
                <td>{data.dueDate}</td>
                <td className='p-0 text-right'>
                  <Svg.Repeat />
                </td>
                <td className='p-0 text-center'>
                  <Svg.Comment />
                </td>
                <td className='p-0 text-left'>
                  <Svg.Lock />
                </td>
                <td className='p-0 text-right'>
                  <button onClick={() => handleRead(data.id)}>Read</button>
                </td>
              </tr>
            );
          })}
        </tbody>
      ) : (
        <tbody>
          <p className='loading'>Loading Data...</p>
        </tbody>
      )}
    </table>
  );
};

export default LatestAnnouncements;
